// generate quantity values 1 to 25 for ComboBox
export const generateQuantityValues = () => {
  const options = []
  const MIN = 1
  const MAX = 25

  for (let i = MIN; i <= MAX; i++) {
    const option = {}
    const iStr = i.toString()
    option.value = iStr
    option.text = iStr
    options.push(option)
  }

  return options
}



// WEBPACK FOOTER //
// ./src/helpers/ComboBoxHelper.js